import React, { memo } from "react";
import { useCarConfigSelector } from "../../../../../redux/store";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import SummarySimilarCar from "./SummarySimilarCar";
import styles from "./SummarySimilarCars.module.scss";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";

const SummarySimilarCars = (): JSX.Element | null => {
    const alternatives = useCarConfigSelector((state) => state.eta.alternatives);
    return (
        <div>
            <Text tag="h2" variant="apheleia-h2" spacing="spacing-4">
                <CarConfigLabel label="carConfigSimilarCarsModalTitle" />
            </Text>
            <div className={styles.similar}>
                {alternatives.map((alternative) => (
                    <SummarySimilarCar
                        key={
                            alternative.id +
                            alternative.body.id +
                            alternative.grade.id +
                            alternative.grade.id +
                            alternative.colour.id +
                            alternative.upholstery.id
                        }
                        alternative={alternative}
                    />
                ))}
            </div>
        </div>
    );
};

export default memo(SummarySimilarCars);
